import PropTypes from 'prop-types';
import styled from 'styled-components';
import { buildStyledComponent, px2rem } from 'decisiv-ui-utils';

/* istanbul ignore next */
const styles = props => `
  color: ${props.theme.colors.base.text};
  font-size: ${px2rem(10)};
  margin-left: ${px2rem(6)};
  text-transform: capitalize;
`;

const themePropTypes = {
  colors: PropTypes.shape({
    base: PropTypes.shape({
      text: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default buildStyledComponent(
  'FollowUpValue',
  styled.span,
  styles,
  { themePropTypes },
);



// WEBPACK FOOTER //
// ./components/_common/FollowUpLabel/FollowUpValue.js